export default __webpack_public_path__ + "media/images/logo-33a0fb4c065a0ccb90b51fcfdea6b3cf.svg";